import { CoreInitiativesByIdName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getInitiativeById } from '@api';

export const coreInitiativesByIdGetAsyncSlice = createGetAsyncSlice({
	name: CoreInitiativesByIdName,
	receive: true,
	request: true,
	requestHandler: getInitiativeById,
	retainDataOnRequest: true
});
